export const regexModule5QuestionBank = [
  // Real-world Text Processing (25 questions)
  {
    id: 'q1',
    question: 'Which regex pattern best extracts email addresses from a large text document?',
    choices: [
      '\\S+@\\S+',
      '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}',
      '\\w+@\\w+\\.\\w+',
      '.*@.*\\..*',
    ],
    correctAnswer: 1,
    explanation:
      'The second pattern provides the most comprehensive and accurate matching for real email addresses while avoiding false positives.',
  },
  {
    id: 'q2',
    question: 'How do you extract all URLs from HTML content?',
    choices: [
      'https?://\\S+',
      'https?://[^\\s<>"]+',
      'https?://[^\\s<>"\\(\\)]+',
      'All patterns have trade-offs',
    ],
    correctAnswer: 3,
    explanation:
      'URL extraction from HTML requires balancing comprehensiveness with avoiding HTML artifacts - each pattern handles different edge cases.',
  },
  {
    id: 'q3',
    question:
      'What pattern efficiently extracts phone numbers in various formats from contact lists?',
    choices: [
      '\\d{3}-\\d{3}-\\d{4}',
      '\\(?\\d{3}\\)?[-\\s.]?\\d{3}[-\\s.]?\\d{4}',
      '(\\+?1[-\\s.]?)?\\(?\\d{3}\\)?[-\\s.]?\\d{3}[-\\s.]?\\d{4}',
      'Pattern C handles most US formats',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C handles US phone numbers with optional country code, area code formatting, and various separators.',
  },
  {
    id: 'q4',
    question: 'Which approach is best for extracting hashtags from social media posts?',
    choices: [
      '#\\w+',
      '#[a-zA-Z0-9_]+',
      '(?<=^|\\s)#[a-zA-Z0-9_]+(?=\\s|$)',
      'Pattern C with word boundaries',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C uses lookbehind/lookahead to ensure hashtags are complete words, not parts of other text.',
  },
  {
    id: 'q5',
    question: 'How do you extract quoted strings from CSV data while handling escaped quotes?',
    choices: [
      '"[^"]*"',
      '"([^"\\\\]|\\\\.)*"',
      '"((?:[^"\\\\]|\\\\.)*)?"',
      'Use proper CSV parser instead',
    ],
    correctAnswer: 3,
    explanation:
      'While pattern B and C handle escaped quotes, CSV parsing has many edge cases better handled by dedicated libraries.',
  },
  {
    id: 'q6',
    question: 'What pattern extracts IP addresses from log files while avoiding false positives?',
    choices: [
      '\\d+\\.\\d+\\.\\d+\\.\\d+',
      '\\b(?:[0-9]{1,3}\\.){3}[0-9]{1,3}\\b',
      '\\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\b',
      'Pattern C validates IP ranges',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C ensures each octet is in the valid range 0-255, preventing false matches like "999.999.999.999".',
  },
  {
    id: 'q7',
    question: 'How do you extract timestamps from log files in format "YYYY-MM-DD HH:MM:SS"?',
    choices: [
      '\\d{4}-\\d{2}-\\d{2} \\d{2}:\\d{2}:\\d{2}',
      '20\\d{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01]) (?:[01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]',
      'Both patterns work with different validation levels',
      'Use datetime parsing libraries',
    ],
    correctAnswer: 2,
    explanation:
      'Both patterns extract timestamps, with pattern B providing better validation for valid date/time ranges.',
  },
  {
    id: 'q8',
    question:
      'What pattern extracts file paths from error messages across different operating systems?',
    choices: [
      '[/\\\\][^\\s:*?"<>|]+',
      '(?:[a-zA-Z]:[/\\\\]|[/\\\\])[^\\s:*?"<>|\\n]+',
      'Both Unix and Windows paths are complex',
      'OS-specific patterns work better',
    ],
    correctAnswer: 3,
    explanation:
      'Cross-platform path extraction is complex due to different path conventions - OS-specific patterns are more reliable.',
  },
  {
    id: 'q9',
    question: 'How do you extract currency amounts from financial documents?',
    choices: [
      '\\$[0-9,]+\\.\\d{2}',
      '[$€£¥]\\s?[0-9,]+(?:\\.[0-9]{2})?',
      '(?:[£$€¥]|USD|EUR|GBP)\\s?[0-9,]+(?:\\.[0-9]{2})?',
      'Pattern C handles multiple currencies',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C handles various currency symbols and codes with optional decimal places and proper formatting.',
  },
  {
    id: 'q10',
    question: 'What pattern extracts version numbers from software release notes?',
    choices: [
      'v?\\d+\\.\\d+\\.\\d+',
      '(?:version\\s+|v)?\\d+(?:\\.\\d+){1,3}(?:-[a-zA-Z0-9]+)?',
      '\\bv?\\d+(?:\\.\\d+)*(?:-(?:alpha|beta|rc)\\d*)?\\b',
      'Pattern B is most comprehensive',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B handles various version formats including semantic versioning, pre-release tags, and build numbers.',
  },
  {
    id: 'q11',
    question: 'How do you extract MAC addresses from network configuration files?',
    choices: [
      '([0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}',
      '[0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}',
      'Both patterns match MAC addresses',
      'Pattern A is more concise',
    ],
    correctAnswer: 3,
    explanation:
      'Both patterns correctly match MAC addresses with either colon or hyphen separators, with pattern A being more concise.',
  },
  {
    id: 'q12',
    question: 'What pattern extracts hashtags from mixed language social media content?',
    choices: [
      '#\\w+',
      '#[\\w\\u00C0-\\u017F\\u4e00-\\u9fff]+',
      '#[^\\s#]+',
      'Unicode-aware patterns needed',
    ],
    correctAnswer: 3,
    explanation:
      'International hashtags require Unicode-aware patterns to handle non-Latin characters properly.',
  },
  {
    id: 'q13',
    question: 'How do you extract code blocks from Markdown documents?',
    choices: [
      '```[\\s\\S]*?```',
      '```(\\w+)?\\n[\\s\\S]*?\\n```',
      '```(?:\\w+\\n)?([\\s\\S]*?)```',
      'Pattern C captures content properly',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C handles optional language specification and captures the actual code content within the fences.',
  },
  {
    id: 'q14',
    question: 'What pattern extracts domain names from a list of URLs?',
    choices: [
      'https?://([^/]+)',
      'https?://(?:www\\.)?([^/]+)',
      'https?://(?:www\\.)?([a-zA-Z0-9.-]+)',
      'Pattern C is most precise',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C captures clean domain names while handling optional www prefix and using precise character classes.',
  },
  {
    id: 'q15',
    question: 'How do you extract error codes from application logs?',
    choices: [
      'ERROR\\s+(\\d+)',
      '(?:ERROR|error)\\s*:?\\s*([A-Z0-9]+)',
      '\\b(?:ERROR|ERR)[-\\s]*([A-Z0-9_-]+)\\b',
      'Pattern C handles various formats',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C handles different error code formats and separators while using word boundaries for precision.',
  },
  {
    id: 'q16',
    question: 'What pattern extracts product codes like "ABC-123" or "XYZ_456"?',
    choices: [
      '[A-Z]{3}[-_]\\d{3}',
      '[A-Z]{2,4}[-_]\\d{2,4}',
      '[A-Z]+[-_]\\d+',
      'Pattern B balances flexibility and precision',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B provides reasonable constraints on length while handling common product code variations.',
  },
  {
    id: 'q17',
    question: 'How do you extract coordinates from GPS data like "40.7128,-74.0060"?',
    choices: [
      '[-+]?\\d+\\.\\d+,[-+]?\\d+\\.\\d+',
      '[-+]?\\d{1,3}\\.\\d{4,6},\\s*[-+]?\\d{1,3}\\.\\d{4,6}',
      '[-+]?(?:[0-9]*\\.)?[0-9]+,\\s*[-+]?(?:[0-9]*\\.)?[0-9]+',
      'Pattern B handles GPS precision',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B specifically handles GPS coordinate format with appropriate precision for latitude/longitude.',
  },
  {
    id: 'q18',
    question: 'What pattern extracts SQL table names from CREATE TABLE statements?',
    choices: [
      'CREATE TABLE (\\w+)',
      'CREATE\\s+TABLE\\s+(?:IF\\s+NOT\\s+EXISTS\\s+)?`?([a-zA-Z_]\\w*)`?',
      'CREATE\\s+TABLE\\s+([^\\s(]+)',
      'Pattern B handles SQL variations',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B handles optional IF NOT EXISTS clause and quoted table names common in SQL.',
  },
  {
    id: 'q19',
    question: 'How do you extract package names from import statements across multiple languages?',
    choices: [
      'import\\s+(\\w+)',
      '(?:import|from|#include)\\s+([\\w./-]+)',
      'Language-specific patterns needed',
      'Pattern C is most appropriate',
    ],
    correctAnswer: 2,
    explanation:
      'Different programming languages have different import syntax - language-specific patterns work better than generic ones.',
  },
  {
    id: 'q20',
    question: 'What pattern extracts license plate numbers from parking violation reports?',
    choices: [
      '[A-Z0-9]{6,8}',
      '[A-Z]{2,3}[-\\s]?[0-9]{3,4}',
      'Regional patterns vary significantly',
      'Multiple patterns needed for different regions',
    ],
    correctAnswer: 2,
    explanation:
      'License plate formats vary dramatically by region/country - generic patterns often fail.',
  },
  {
    id: 'q21',
    question: 'How do you extract medical record numbers like "MR-12345678"?',
    choices: [
      'MR-\\d{8}',
      '(?:MR|mr)[-\\s]?\\d{6,10}',
      '[A-Z]{2,3}[-\\s]?\\d{6,10}',
      'Pattern B handles common variations',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B handles case variations and flexible separators while maintaining reasonable number length constraints.',
  },
  {
    id: 'q22',
    question: 'What pattern extracts bibliographic citations in APA format?',
    choices: [
      '\\w+,\\s*\\w+\\s*\\(\\d{4}\\)',
      '[A-Z][a-z]+,\\s*[A-Z]\\.?\\s*\\(\\d{4}\\)',
      'Citation parsing is very complex',
      'Use specialized citation parsers',
    ],
    correctAnswer: 2,
    explanation:
      'Academic citations have complex formatting rules that vary by style - specialized parsers are more reliable.',
  },
  {
    id: 'q23',
    question: 'How do you extract chemical formulas like "H2SO4" from scientific text?',
    choices: [
      '[A-Z][a-z]?\\d*',
      '[A-Z][a-z]?(\\d+)?(?:[A-Z][a-z]?(\\d+)?)*',
      '(?:[A-Z][a-z]?\\d*)+',
      'Pattern C handles compound formulas',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C correctly matches compound chemical formulas with multiple elements and subscripts.',
  },
  {
    id: 'q24',
    question: 'What pattern extracts Git commit hashes from repository logs?',
    choices: [
      '[0-9a-f]{40}',
      '[0-9a-f]{7,40}',
      '\\b[0-9a-f]{7,40}\\b',
      'Pattern C with word boundaries',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern C handles both full (40-char) and abbreviated (7+ char) commit hashes with word boundaries for precision.',
  },
  {
    id: 'q25',
    question: 'How do you extract IBAN bank account numbers from financial documents?',
    choices: [
      '[A-Z]{2}\\d{2}[A-Z0-9]{4}\\d{7}[A-Z0-9]{0,16}',
      '[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}',
      'IBAN validation is complex',
      'Use banking libraries for validation',
    ],
    correctAnswer: 2,
    explanation:
      'IBAN has complex country-specific validation rules beyond format - banking libraries provide proper validation.',
  },

  // Data Validation and Cleaning (25 questions)
  {
    id: 'q26',
    question: 'How do you validate email addresses while allowing common international formats?',
    choices: [
      '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
      '^[\\w._%+-]+@[\\w.-]+\\.[a-zA-Z]{2,}$',
      'Use proper email validation libraries',
      'Pattern A is more restrictive and safer',
    ],
    correctAnswer: 2,
    explanation:
      'Email validation has many edge cases and international considerations - dedicated libraries handle these properly.',
  },
  {
    id: 'q27',
    question:
      'What regex approach validates strong passwords (8+ chars, mixed case, digits, symbols)?',
    choices: [
      '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}',
      '.{8,}',
      'Check each requirement separately',
      'Pattern A uses lookaheads effectively',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern A uses positive lookaheads to ensure all password requirements are met without requiring specific order.',
  },
  {
    id: 'q28',
    question: 'How do you validate US phone numbers in multiple formats?',
    choices: [
      '^\\(?\\d{3}\\)?[-\\s.]?\\d{3}[-\\s.]?\\d{4}$',
      '^(\\+?1[-\\s.]?)?\\(?\\d{3}\\)?[-\\s.]?\\d{3}[-\\s.]?\\d{4}$',
      'Multiple patterns for different formats',
      'Pattern B handles most variations',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B handles US phone numbers with optional country code and various formatting options.',
  },
  {
    id: 'q29',
    question: 'What pattern validates IPv4 addresses ensuring valid octet ranges?',
    choices: [
      '^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$',
      '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
      'Both work but pattern B validates ranges',
      'Use IP address parsing libraries',
    ],
    correctAnswer: 2,
    explanation:
      'While both match IP format, pattern B ensures each octet is in the valid range 0-255.',
  },
  {
    id: 'q30',
    question: 'How do you validate credit card numbers (format, not financial validity)?',
    choices: [
      '^\\d{16}$',
      '^\\d{4}[-\\s]?\\d{4}[-\\s]?\\d{4}[-\\s]?\\d{4}$',
      'Different patterns for different card types',
      'Use financial processing libraries',
    ],
    correctAnswer: 2,
    explanation:
      'Different credit card types have different length and format requirements - specific patterns work better.',
  },
  {
    id: 'q31',
    question: 'What approach validates dates in MM/DD/YYYY format with proper month/day ranges?',
    choices: [
      '^\\d{2}/\\d{2}/\\d{4}$',
      '^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/(19|20)\\d{2}$',
      'Use date parsing libraries',
      'Pattern B provides basic validation',
    ],
    correctAnswer: 2,
    explanation:
      'Date validation has many edge cases (leap years, month lengths) that libraries handle better than regex.',
  },
  {
    id: 'q32',
    question: 'How do you validate postal codes for multiple countries?',
    choices: [
      '^\\d{5}$',
      '^[A-Z0-9\\s-]{3,10}$',
      'Country-specific patterns needed',
      'Use geographic data libraries',
    ],
    correctAnswer: 2,
    explanation:
      'Postal codes vary dramatically by country in format, length, and character sets - country-specific validation is needed.',
  },
  {
    id: 'q33',
    question: 'What pattern validates hexadecimal color codes including 3 and 6 digit formats?',
    choices: [
      '^#[0-9A-Fa-f]{6}$',
      '^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$',
      '^#[0-9A-Fa-f]{3,6}$',
      'Pattern B handles both formats correctly',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B uses alternation to match either 3-digit or 6-digit hex color codes properly.',
  },
  {
    id: 'q34',
    question: 'How do you validate URLs while handling different protocols and formats?',
    choices: [
      '^https?://.*',
      '^https?://[^\\s/$.?#].[^\\s]*$',
      'Use URL parsing libraries',
      'URL validation is extremely complex',
    ],
    correctAnswer: 2,
    explanation:
      'URL validation has many edge cases and international domain considerations - proper libraries are essential.',
  },
  {
    id: 'q35',
    question:
      'What approach validates Social Security Numbers (XXX-XX-XXXX) while avoiding reserved ranges?',
    choices: [
      '^\\d{3}-\\d{2}-\\d{4}$',
      '^(?!000|666)[0-8]\\d{2}-(?!00)\\d{2}-(?!0000)\\d{4}$',
      'Basic format check then programmatic validation',
      'Pattern B handles some reserved ranges',
    ],
    correctAnswer: 2,
    explanation:
      'SSN has complex reserved number rules that are better handled programmatically after basic format validation.',
  },
  {
    id: 'q36',
    question: 'How do you clean and validate international phone numbers?',
    choices: [
      'Strip non-digits then validate length',
      '^\\+[1-9]\\d{1,14}$',
      'Use libphonenumber or similar',
      'Country-specific validation needed',
    ],
    correctAnswer: 2,
    explanation:
      'International phone number validation is extremely complex - specialized libraries like libphonenumber are essential.',
  },
  {
    id: 'q37',
    question: 'What pattern validates MAC addresses in both colon and hyphen formats?',
    choices: [
      '^([0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}$',
      '^[0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}[:-][0-9A-Fa-f]{2}$',
      'Both patterns work',
      'Pattern A is more concise',
    ],
    correctAnswer: 3,
    explanation:
      'Both patterns correctly validate MAC addresses with either separator, with pattern A being more maintainable.',
  },
  {
    id: 'q38',
    question: 'How do you validate version numbers in semantic versioning format (X.Y.Z)?',
    choices: [
      '^\\d+\\.\\d+\\.\\d+$',
      '^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(?:-((?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\\+([0-9a-zA-Z-]+(?:\\.[0-9a-zA-Z-]+)*))?$',
      'Pattern A for basic, Pattern B for full semver',
      'Use semver parsing libraries',
    ],
    correctAnswer: 3,
    explanation:
      'Basic version validation can use simple patterns, but full semantic versioning has complex rules better handled by libraries.',
  },
  {
    id: 'q39',
    question: 'What approach validates IBAN international bank account numbers?',
    choices: [
      '^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$',
      'Format check then mod-97 algorithm',
      'Use banking validation libraries',
      'IBAN validation requires checksum calculation',
    ],
    correctAnswer: 3,
    explanation:
      'IBAN validation requires both format checking and checksum validation using the mod-97 algorithm.',
  },
  {
    id: 'q40',
    question: 'How do you validate Bitcoin addresses?',
    choices: [
      '^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$',
      '^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,87}$',
      'Use cryptocurrency libraries',
      'Bitcoin address validation requires checksum',
    ],
    correctAnswer: 2,
    explanation:
      'Bitcoin addresses have complex encoding and checksum validation that requires specialized cryptocurrency libraries.',
  },
  {
    id: 'q41',
    question: 'What pattern validates time in 24-hour format (HH:MM)?',
    choices: [
      '^\\d{2}:\\d{2}$',
      '^([01]?[0-9]|2[0-3]):[0-5][0-9]$',
      '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$',
      'Pattern B handles flexible hour format',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern B allows single-digit hours (1:30) or double-digit (01:30) while maintaining valid ranges.',
  },
  {
    id: 'q42',
    question: 'How do you validate ISBN-13 numbers (format: 978-1-234-56789-0)?',
    choices: [
      '^978-\\d{1}-\\d{3}-\\d{5}-\\d{1}$',
      '^97[89]-\\d{1,5}-\\d{1,7}-\\d{1,6}-\\d{1}$',
      'Format check then checksum validation',
      'Use book/publishing libraries',
    ],
    correctAnswer: 2,
    explanation:
      'ISBN validation requires both format checking and checksum calculation - format varies by publisher.',
  },
  {
    id: 'q43',
    question: 'What approach validates longitude/latitude coordinates?',
    choices: [
      '^[-+]?\\d+\\.\\d+$',
      '^[-+]?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?),\\s*[-+]?(180(\\.0+)?|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d+)?)$',
      'Range validation after format check',
      'Use geographic libraries',
    ],
    correctAnswer: 2,
    explanation:
      'Coordinate validation has complex range requirements (lat: -90 to 90, lng: -180 to 180) best handled after format validation.',
  },
  {
    id: 'q44',
    question: 'How do you validate file extensions for security purposes?',
    choices: [
      '\\.(jpg|jpeg|png|gif|pdf|doc|docx)$',
      'Use whitelist approach with exact matching',
      'Check file content, not just extension',
      'All approaches needed for security',
    ],
    correctAnswer: 3,
    explanation:
      'File security requires multiple layers: extension whitelisting, content validation, and mime type checking.',
  },
  {
    id: 'q45',
    question: 'What pattern validates UUID/GUID format?',
    choices: [
      '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$',
      '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$',
      'Pattern A for format, Pattern B for version validation',
      'Use UUID libraries for proper validation',
    ],
    correctAnswer: 2,
    explanation:
      'Pattern A validates basic UUID format, Pattern B validates version and variant bits, but libraries handle edge cases better.',
  },
  {
    id: 'q46',
    question: 'How do you validate HTML color names alongside hex codes?',
    choices: [
      '^(#[0-9A-Fa-f]{3,6}|red|blue|green|...)$',
      'Use comprehensive color name list',
      'Combine hex pattern with color name enum',
      'Use CSS/HTML color libraries',
    ],
    correctAnswer: 3,
    explanation:
      'HTML color validation should use established color libraries that maintain current color name specifications.',
  },
  {
    id: 'q47',
    question: 'What approach validates JSON Web Token (JWT) format?',
    choices: [
      '^[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]+\\.[A-Za-z0-9_-]+$',
      'Format check then decode and validate',
      'Use JWT libraries for validation',
      'JWT validation requires signature verification',
    ],
    correctAnswer: 2,
    explanation:
      'JWT validation requires format checking, base64 decoding, and cryptographic signature verification using JWT libraries.',
  },
  {
    id: 'q48',
    question: 'How do you validate regex patterns themselves for safety?',
    choices: [
      'Check for catastrophic backtracking patterns',
      'Limit quantifiers and nesting depth',
      'Use regex analysis tools',
      'All approaches needed for regex safety',
    ],
    correctAnswer: 3,
    explanation:
      'Regex safety requires multiple checks: backtracking analysis, complexity limits, and specialized analysis tools.',
  },
  {
    id: 'q49',
    question: 'What pattern validates domain names according to RFC specifications?',
    choices: [
      '^[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
      '^([a-zA-Z0-9]([a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?\\.)++[a-zA-Z]{2,}$',
      'Use domain parsing libraries',
      'RFC-compliant validation is complex',
    ],
    correctAnswer: 2,
    explanation:
      'Domain name validation has complex RFC requirements for length, characters, and structure that libraries handle properly.',
  },
  {
    id: 'q50',
    question: 'How do you validate and sanitize user input containing potential regex injection?',
    choices: [
      'Escape all regex metacharacters',
      'Use literal string matching only',
      'Validate against whitelist patterns',
      'Never trust user regex input',
    ],
    correctAnswer: 3,
    explanation:
      'User-provided regex can cause denial of service and security issues - validate against strict whitelists or avoid entirely.',
  },

  // Advanced Pattern Applications (25 questions)
  {
    id: 'q51',
    question: 'How do you implement fuzzy string matching using regex?',
    choices: [
      'Use edit distance algorithms instead',
      'Create patterns with optional characters',
      'Use approximate matching libraries',
      'Regex is not suitable for fuzzy matching',
    ],
    correctAnswer: 3,
    explanation:
      'Fuzzy matching requires algorithms like Levenshtein distance or specialized libraries - regex is too rigid for fuzzy matching.',
  },
  {
    id: 'q52',
    question: 'What approach handles regex matching in streaming data?',
    choices: [
      'Buffer partial matches across chunks',
      'Use streaming regex engines',
      'Process overlapping windows',
      'All approaches have trade-offs',
    ],
    correctAnswer: 3,
    explanation:
      'Streaming regex requires careful buffer management to avoid missing matches that span chunk boundaries.',
  },
  {
    id: 'q53',
    question: 'How do you optimize regex performance for large text processing?',
    choices: [
      'Compile patterns once and reuse',
      'Use non-capturing groups where possible',
      'Avoid catastrophic backtracking',
      'All optimizations are important',
    ],
    correctAnswer: 3,
    explanation:
      'Regex performance requires multiple optimizations: compilation reuse, efficient grouping, and backtracking prevention.',
  },
  {
    id: 'q54',
    question: 'What pattern implements a simple lexical analyzer for programming languages?',
    choices: [
      'Multiple patterns for different token types',
      '(\\d+|\\w+|[+\\-*/]|[()])',
      'Use lexer generator tools',
      'Hand-written lexers are more efficient',
    ],
    correctAnswer: 2,
    explanation:
      'Simple lexical analysis can use alternation patterns, but complex languages benefit from dedicated lexer tools.',
  },
  {
    id: 'q55',
    question: 'How do you implement syntax highlighting using regex?',
    choices: [
      'Multiple regex passes for different elements',
      'Single complex regex with capture groups',
      'Use syntax highlighting libraries',
      'State-based parsing for complex languages',
    ],
    correctAnswer: 2,
    explanation:
      'Professional syntax highlighting uses specialized libraries or parsers that understand language grammar properly.',
  },
  {
    id: 'q56',
    question: 'What approach handles nested structures like balanced brackets using regex?',
    choices: [
      'Recursive regex patterns (if supported)',
      'Use parsing algorithms instead',
      'Count-based approaches',
      'Regex cannot handle arbitrary nesting',
    ],
    correctAnswer: 3,
    explanation:
      'Regular expressions cannot handle arbitrary nested structures - use recursive descent parsers or stack-based approaches.',
  },
  {
    id: 'q57',
    question: 'How do you implement regex-based template engines?',
    choices: [
      'Replace placeholders with values',
      'Parse template syntax with regex',
      'Use established template engines',
      'Simple substitution vs complex parsing',
    ],
    correctAnswer: 3,
    explanation:
      'Simple templates can use regex substitution, but complex template engines need proper parsers for control flow.',
  },
  {
    id: 'q58',
    question: 'What pattern extracts structured data from unstructured text documents?',
    choices: [
      'Named capture groups for fields',
      'Multiple passes with different patterns',
      'Machine learning for extraction',
      'Depends on document structure complexity',
    ],
    correctAnswer: 3,
    explanation:
      'Simple structured data can use regex, but complex document parsing benefits from ML or specialized extraction tools.',
  },
  {
    id: 'q59',
    question: 'How do you implement regex-based URL routing?',
    choices: [
      'Pattern matching with parameter extraction',
      'Use web framework routing',
      'Trie-based routing for performance',
      'Simple patterns work for basic routing',
    ],
    correctAnswer: 3,
    explanation:
      'Basic URL routing can use regex patterns, but high-performance applications benefit from specialized routing algorithms.',
  },
  {
    id: 'q60',
    question: 'What approach implements regex-based log parsing and analysis?',
    choices: [
      'Structured patterns for log formats',
      'Named groups for field extraction',
      'Use log processing tools like ELK stack',
      'All approaches valid for different scales',
    ],
    correctAnswer: 3,
    explanation:
      'Log parsing scales from simple regex patterns to enterprise tools depending on volume and complexity requirements.',
  },
  {
    id: 'q61',
    question: 'How do you handle regex matching across multiple languages/encodings?',
    choices: [
      'Unicode-aware regex engines',
      'UTF-8 normalization before matching',
      'Language-specific character classes',
      'Unicode support is essential',
    ],
    correctAnswer: 3,
    explanation:
      'International text processing requires Unicode-aware regex engines and proper normalization handling.',
  },
  {
    id: 'q62',
    question: 'What pattern implements regex-based data transformation pipelines?',
    choices: [
      'Chain multiple regex operations',
      'Use data processing frameworks',
      'Combine regex with other tools',
      'Regex best for simple transformations',
    ],
    correctAnswer: 3,
    explanation:
      'Data pipelines benefit from combining regex with proper data processing frameworks for complex transformations.',
  },
  {
    id: 'q63',
    question: 'How do you implement regex-based configuration file parsing?',
    choices: [
      'Patterns for key-value pairs',
      'Section-based parsing with state',
      'Use configuration parsing libraries',
      'Depends on configuration complexity',
    ],
    correctAnswer: 3,
    explanation:
      'Simple configs can use regex, but complex formats (JSON, YAML, TOML) need specialized parsers.',
  },
  {
    id: 'q64',
    question: 'What approach handles regex-based code refactoring?',
    choices: [
      'Search and replace with capture groups',
      'AST-based refactoring tools',
      'IDE refactoring features',
      'Regex suitable for simple changes only',
    ],
    correctAnswer: 3,
    explanation:
      'Simple textual changes can use regex, but semantic refactoring requires AST-based tools that understand code structure.',
  },
  {
    id: 'q65',
    question: 'How do you implement regex-based text classification?',
    choices: [
      'Pattern matching for categories',
      'Machine learning classifiers',
      'Rule-based classification systems',
      'Depends on classification complexity',
    ],
    correctAnswer: 3,
    explanation:
      'Simple rule-based classification can use regex, but complex text classification benefits from ML approaches.',
  },
  {
    id: 'q66',
    question: 'What pattern implements regex-based API response parsing?',
    choices: [
      'Extract specific fields with patterns',
      'Use JSON/XML parsing libraries',
      'Structured data needs proper parsers',
      'Regex only for simple text responses',
    ],
    correctAnswer: 2,
    explanation:
      'Structured API responses (JSON/XML) should use proper parsers - regex is only suitable for simple text responses.',
  },
  {
    id: 'q67',
    question: 'How do you handle regex performance monitoring and optimization?',
    choices: [
      'Profile regex execution time',
      'Monitor backtracking and complexity',
      'Use regex analysis tools',
      'All monitoring approaches needed',
    ],
    correctAnswer: 3,
    explanation:
      'Regex performance requires comprehensive monitoring: execution time, backtracking analysis, and complexity assessment.',
  },
  {
    id: 'q68',
    question: 'What approach implements regex-based security scanning?',
    choices: [
      'Patterns for vulnerability signatures',
      'Combine with static analysis tools',
      'Use security scanning frameworks',
      'Multi-layered security analysis needed',
    ],
    correctAnswer: 3,
    explanation:
      'Security scanning combines regex patterns with comprehensive static analysis and specialized security tools.',
  },
  {
    id: 'q69',
    question: 'How do you implement regex-based database query optimization?',
    choices: [
      'Pattern matching for query types',
      'Use database query analyzers',
      'AST-based query optimization',
      'Regex unsuitable for query optimization',
    ],
    correctAnswer: 3,
    explanation:
      'Query optimization requires understanding SQL semantics and execution plans - regex is too simplistic for this task.',
  },
  {
    id: 'q70',
    question: 'What pattern implements regex-based markup language processing?',
    choices: [
      'Tag matching with nested handling',
      'State machine for complex markup',
      'Use markup parsing libraries',
      'Depends on markup complexity',
    ],
    correctAnswer: 3,
    explanation:
      'Simple markup can use regex, but complex nested markup languages need proper parsers or state machines.',
  },
  {
    id: 'q71',
    question: 'How do you handle regex-based real-time text processing?',
    choices: [
      'Streaming regex engines',
      'Buffered processing with overlap',
      'Asynchronous pattern matching',
      'All approaches have performance implications',
    ],
    correctAnswer: 3,
    explanation:
      'Real-time text processing requires careful consideration of latency, throughput, and buffer management strategies.',
  },
  {
    id: 'q72',
    question: 'What approach implements regex-based natural language processing?',
    choices: [
      'Pattern matching for linguistic features',
      'Combine regex with NLP libraries',
      'Use specialized NLP frameworks',
      'Regex useful for simple text features only',
    ],
    correctAnswer: 3,
    explanation:
      'NLP requires understanding of grammar, semantics, and context - regex is only useful for simple pattern detection.',
  },
  {
    id: 'q73',
    question: 'How do you implement regex-based code generation?',
    choices: [
      'Template substitution with patterns',
      'AST-based code generation',
      'Use code generation frameworks',
      'Depends on generation complexity',
    ],
    correctAnswer: 3,
    explanation:
      'Simple template-based generation can use regex, but complex code generation benefits from AST-based approaches.',
  },
  {
    id: 'q74',
    question: 'What pattern implements regex-based distributed text processing?',
    choices: [
      'Map-reduce with regex operations',
      'Streaming processing frameworks',
      'Distributed regex engines',
      'Scale determines architecture choice',
    ],
    correctAnswer: 3,
    explanation:
      'Distributed text processing scales from simple map-reduce patterns to complex streaming frameworks based on requirements.',
  },
  {
    id: 'q75',
    question: 'How do you implement regex-based machine learning feature extraction?',
    choices: [
      'Pattern-based feature engineering',
      'Combine regex with ML pipelines',
      'Use automated feature extraction',
      'Regex provides simple text features',
    ],
    correctAnswer: 3,
    explanation:
      'Regex can extract basic text features for ML, but modern feature extraction benefits from automated and deep learning approaches.',
  },

  // Performance and Best Practices (25 questions)
  {
    id: 'q76',
    question: 'What is catastrophic backtracking in regex?',
    choices: [
      'When regex takes exponential time',
      'When patterns fail to match',
      'When regex engines crash',
      'When memory usage is too high',
    ],
    correctAnswer: 0,
    explanation:
      'Catastrophic backtracking occurs when regex engines try many unsuccessful paths, leading to exponential time complexity.',
  },
  {
    id: 'q77',
    question: 'How do you prevent catastrophic backtracking?',
    choices: [
      'Use atomic groups',
      'Avoid nested quantifiers',
      'Use possessive quantifiers',
      'All techniques help prevent backtracking',
    ],
    correctAnswer: 3,
    explanation:
      'Multiple techniques prevent backtracking: atomic groups, possessive quantifiers, and careful quantifier design.',
  },
  {
    id: 'q78',
    question: 'When should you use non-capturing groups (?:...)?',
    choices: [
      "When you don't need to extract the group",
      'For better performance',
      'To reduce memory usage',
      'All reasons are valid',
    ],
    correctAnswer: 3,
    explanation:
      'Non-capturing groups improve performance and reduce memory when you only need grouping for precedence, not extraction.',
  },
  {
    id: 'q79',
    question: 'What is the most efficient way to match multiple alternatives?',
    choices: [
      'Use alternation (|) with longest alternatives first',
      'Use character classes when possible',
      'Use multiple regex patterns',
      'Efficiency depends on the specific alternatives',
    ],
    correctAnswer: 3,
    explanation:
      'Character classes are fastest for single characters, alternation works for strings, but optimal choice depends on specific patterns.',
  },
  {
    id: 'q80',
    question: 'How do anchors (^, $) affect regex performance?',
    choices: [
      'They generally improve performance',
      'They have no performance impact',
      'They slow down matching',
      'Impact depends on text length and pattern',
    ],
    correctAnswer: 0,
    explanation:
      'Anchors typically improve performance by preventing unnecessary searching in text where matches are impossible.',
  },
  {
    id: 'q81',
    question: 'What is the performance difference between greedy and lazy quantifiers?',
    choices: [
      'Greedy is always faster',
      'Lazy is always faster',
      'Performance depends on the text and pattern',
      'No significant difference',
    ],
    correctAnswer: 2,
    explanation:
      'Performance depends on text content - greedy may be faster when matches are long, lazy when matches are short.',
  },
  {
    id: 'q82',
    question: 'When should you compile regex patterns?',
    choices: [
      'Always compile for better performance',
      'Only when using patterns repeatedly',
      'Compilation overhead is negligible',
      'Modern engines auto-compile patterns',
    ],
    correctAnswer: 1,
    explanation:
      'Compilation has overhead - only worthwhile when using the same pattern multiple times to amortize the cost.',
  },
  {
    id: 'q83',
    question: 'How do you optimize regex for large files?',
    choices: [
      'Process files in chunks',
      'Use memory-mapped files',
      'Stream processing with buffers',
      'All approaches can be effective',
    ],
    correctAnswer: 3,
    explanation:
      'Large file processing benefits from various approaches: chunking, memory mapping, or streaming based on requirements.',
  },
  {
    id: 'q84',
    question: 'What is the impact of Unicode support on regex performance?',
    choices: [
      'Significant performance overhead',
      'Minimal impact with modern engines',
      'Only affects character class matching',
      'Impact varies by regex engine and text',
    ],
    correctAnswer: 3,
    explanation:
      'Unicode impact varies - modern engines optimize common cases, but complex Unicode operations can have overhead.',
  },
  {
    id: 'q85',
    question: 'How do you benchmark regex performance effectively?',
    choices: [
      'Time multiple runs with realistic data',
      'Test with various input sizes',
      'Compare different pattern approaches',
      'All practices are important for accurate benchmarking',
    ],
    correctAnswer: 3,
    explanation:
      'Effective benchmarking requires multiple runs, realistic data, various sizes, and pattern comparisons for meaningful results.',
  },
  {
    id: 'q86',
    question: 'What regex patterns should you avoid for performance?',
    choices: [
      'Nested quantifiers like (a+)+',
      'Alternation with overlapping patterns',
      'Deep nesting of groups',
      'All patterns can cause performance issues',
    ],
    correctAnswer: 3,
    explanation:
      'Multiple patterns cause performance issues: nested quantifiers, overlapping alternation, and deep nesting all create problems.',
  },
  {
    id: 'q87',
    question: 'How do different regex engines compare in performance?',
    choices: [
      'PCRE is always fastest',
      'Built-in engines are most optimized',
      'Performance varies by use case',
      'Modern engines have similar performance',
    ],
    correctAnswer: 2,
    explanation:
      'Engine performance varies significantly by use case - some excel at simple patterns, others at complex ones.',
  },
  {
    id: 'q88',
    question: 'What is the memory usage of different regex operations?',
    choices: [
      'Capturing groups use most memory',
      'Backtracking creates memory pressure',
      'Compiled patterns have fixed overhead',
      'Memory usage depends on pattern complexity',
    ],
    correctAnswer: 3,
    explanation:
      'Memory usage varies: capturing groups store matches, backtracking uses stack space, compilation has overhead.',
  },
  {
    id: 'q89',
    question: 'How do you handle regex timeouts and limits?',
    choices: [
      'Set execution time limits',
      'Limit backtracking steps',
      'Use interruptible regex engines',
      'All approaches help prevent runaway patterns',
    ],
    correctAnswer: 3,
    explanation:
      'Regex safety requires multiple limits: execution time, backtracking steps, and interruptible engines for user control.',
  },
  {
    id: 'q90',
    question: 'What are the best practices for regex code maintenance?',
    choices: [
      'Document complex patterns thoroughly',
      'Use named groups for clarity',
      'Test with comprehensive test cases',
      'All practices improve maintainability',
    ],
    correctAnswer: 3,
    explanation:
      'Maintainable regex requires documentation, named groups, comprehensive testing, and clear pattern organization.',
  },
  {
    id: 'q91',
    question: 'How do you debug complex regex patterns?',
    choices: [
      'Use regex debugging tools',
      'Break patterns into smaller parts',
      'Test with step-by-step input',
      'All debugging approaches are valuable',
    ],
    correctAnswer: 3,
    explanation:
      'Regex debugging benefits from specialized tools, incremental development, and systematic testing approaches.',
  },
  {
    id: 'q92',
    question: 'What is the impact of regex flags on performance?',
    choices: [
      'Case-insensitive matching is slower',
      'Multiline mode affects anchor performance',
      'Global matching repeats the engine work',
      'Flag impact varies by engine and pattern',
    ],
    correctAnswer: 3,
    explanation:
      'Regex flags have varying performance impacts depending on the engine, pattern complexity, and text characteristics.',
  },
  {
    id: 'q93',
    question: 'How do you profile regex performance in applications?',
    choices: [
      'Use application profilers',
      'Add timing around regex operations',
      'Monitor regex-specific metrics',
      'All profiling methods provide valuable insights',
    ],
    correctAnswer: 3,
    explanation:
      'Comprehensive regex profiling uses application profilers, custom timing, and regex-specific metrics for complete analysis.',
  },
  {
    id: 'q94',
    question: 'What are common regex anti-patterns to avoid?',
    choices: [
      'Using .* when specific patterns work',
      'Nested quantifiers without anchoring',
      'Alternation instead of character classes',
      'All patterns reduce efficiency and clarity',
    ],
    correctAnswer: 3,
    explanation:
      'Common anti-patterns include overly generic patterns, nested quantifiers, and inefficient alternation usage.',
  },
  {
    id: 'q95',
    question: 'How do you optimize regex for different types of text?',
    choices: [
      'Structured data needs precise patterns',
      'Natural language benefits from flexible matching',
      'Code parsing requires syntax-aware patterns',
      'Optimization strategy depends on text type',
    ],
    correctAnswer: 3,
    explanation:
      'Different text types benefit from different optimization strategies based on structure, variability, and requirements.',
  },
  {
    id: 'q96',
    question: 'What is the role of regex in modern text processing pipelines?',
    choices: [
      'Primary tool for simple pattern matching',
      'Combined with ML for complex analysis',
      'Preprocessing step for structured parsing',
      'All roles depending on pipeline requirements',
    ],
    correctAnswer: 3,
    explanation:
      'Modern pipelines use regex for various roles: simple matching, ML preprocessing, and structured parsing depending on needs.',
  },
  {
    id: 'q97',
    question: 'How do you ensure regex security in applications?',
    choices: [
      'Validate user-provided patterns',
      'Set execution limits and timeouts',
      'Use safe pattern construction methods',
      'All security measures are important',
    ],
    correctAnswer: 3,
    explanation:
      'Regex security requires pattern validation, execution limits, and safe construction to prevent DoS and injection attacks.',
  },
  {
    id: 'q98',
    question: 'What are the scalability considerations for regex processing?',
    choices: [
      'Pattern compilation caching',
      'Parallel processing of independent matches',
      'Streaming processing for large datasets',
      'All approaches improve scalability',
    ],
    correctAnswer: 3,
    explanation:
      'Regex scalability benefits from compilation caching, parallelization, and streaming processing for large-scale applications.',
  },
  {
    id: 'q99',
    question: 'How do you choose between regex and other text processing tools?',
    choices: [
      'Use regex for simple pattern matching',
      'Use parsers for structured data',
      'Use ML for complex text understanding',
      'Choice depends on specific requirements',
    ],
    correctAnswer: 3,
    explanation:
      'Tool choice depends on complexity: regex for patterns, parsers for structure, ML for understanding, and combinations for complex tasks.',
  },
  {
    id: 'q100',
    question: 'What is the future of regex in text processing?',
    choices: [
      'Continued relevance for pattern matching',
      'Integration with ML and AI systems',
      'Enhanced performance and Unicode support',
      'Regex remains fundamental with evolving applications',
    ],
    correctAnswer: 3,
    explanation:
      'Regex remains fundamental for pattern matching while evolving to integrate with modern AI/ML systems and improved engines.',
  },
];
